const lightTheme = {
  background: '#eff1ed',
  colors: {
    cards: '#80a4ed',
    cardsShadow: 'rgba(0, 0, 0, 0.5)',
    cardsText: 'black',
    cardsButton: 'white',
    text: 'white',
    header: '#dd7596',
    darkModeButtonText: 'white',
    searchColor: 'black',
    searchBackgroundColor: 'white',
    modalBackground: 'white',
    modalButton: 'white',
    modalButtonBorder: '1px solid black',
    modalButtonColor: 'black',
    modalTextColor: 'black',
    modalVerticalDividerColor: 'rgba(181, 181, 181, 0.2)',
    modalLinkColor: 'blue',
  },
};

const darkTheme = {
  background: '#001524',
  colors: {
    cards: '#15616d',
    cardsShadow: 'rgba(255, 255, 255, 0.3)',
    cardsText: 'white',
    cardsButton: '#3ca7b7',
    text: 'black',
    header: '#3ca7b7',
    darkModeButtonText: 'black',
    searchColor: 'white',
    searchBackgroundColor: '#704c5e',
    modalBackground: '#3ca7b7',
    modalButton: '#15616d',
    modalButtonBorder: 'none',
    modalButtonColor: 'white',
    modalTextColor: 'white',
    modalVerticalDividerColor: 'rgba(255, 255, 255, 0.2)',
    modalLinkColor: 'blue',
  },
};

const themes = {
  lightTheme,
  darkTheme,
};

export default themes;
